import React from 'react'
import './css/Contact.css'
import { HiUser, HiOutlineMailOpen } from 'react-icons/hi'
import { SiMinutemailer } from 'react-icons/si'


function Contact() {

    

  return ( 

  
    <div>

<section id="contact">
        <div className="wrapper">

            <div className="left">
                <div className="contact-heading">
                    Contact Me
                </div>
                <div className="contact-desc">
                    I'm a web developer from Kolkata, West Bengal, India.

                </div>

                <iframe 
                title='address'
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d387.39230894268!2d88.48172681669719!3d22.52227850761939!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a020b9855d3c2e1%3A0xd182c9167e374c82!2zS3Jpc2huYSBUZW1wbGUgKOCmleCng-Cmt-CnjeCmoyDgpq7gpqjgp43gpqbgpr_gprApLCBDaGFyY2hhcml5YSBQYXJhLCBXQg!5e0!3m2!1sen!2sin!4v1663563657589!5m2!1sen!2sin" 
                width="100%" 
                height="450" 
                style={{border: 0}}
                allowFullScreen="" 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
                ></iframe>

            </div>

            <div className="right">
                <form action='https://formspree.io/f/xdojeyyw' className="form-wrapper" method='POST'>
                    <div className="form-group">
                        <label htmlFor="name">Name</label>
                        <div className="input-wrapper">
                            <div className="icon"><HiUser/></div>
                            <input 
                            type="text" 
                            placeholder="Enter Your Name" 
                            id="name" 
                            name="username"
                            autoComplete='off'
                            required
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <div className="input-wrapper">
                            <div className="icon"><HiOutlineMailOpen/></div>
                            <input 
                            type="email" 
                            placeholder="Enter Your Email" 
                            id="email" 
                            name="Email"
                            autoComplete='off'
                            required
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="text-box">Message</label>
                        <textarea 
                        placeholder='Enter Your Message'
                        name="message" 
                        id="text-box"
                        autoComplete='off'
                        required
                        />
                    </div>
                    <button type="submit" value="Send">Send <SiMinutemailer/></button>
                </form>
            </div>

        </div>
    </section>

    </div>
  )
}

export default Contact